import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { AuthService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { take, takeUntil } from "rxjs/operators";
import { BackUpModel } from "./backUp.model";
import { form_control } from "projects/sepidz-web-framework/src/lib/models/form-control.model";
@Component({
  selector: "backUpComponent",
  templateUrl: "./backUp.component.html",
  styleUrls: ["./backUp.component.scss"],
})
export class backUpComponent extends BaseFormComponent<BackUpModel> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private authService: AuthService) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "";
    this.areaName = "General";
    this.label = this.translate("ClientApp.Projects.FrameWorkShell.Header.BackUp.BackUp");
    super.ngOnInit();
    this.setColumns();
  }

  async setColumns() {
    this.columns = [];
    this.httpCommonService
      .get("UserLocalSetting/GetBackUpModel")
      .pipe(take(1))
      .subscribe(
        (data: form_control[]) => {
          const hasAccess = this.accountService.userHasPermission("General:UserLocalSetting", "BackUpInfoAccess");
          if (hasAccess) {
            this.columns = data;
            this.orignalColumns = this.columns;
            this.setFormGroup(this.model);
            this.cd.markForCheck();
          } else {
            data.forEach((val) => {
              val.disabled = true;
            });
            this.columns = data;
            this.orignalColumns = this.columns;
            this.setFormGroup(this.model);
            this.cd.markForCheck();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  addControl() {
    this.httpCommonService
      .get("UserLocalSetting/GetBackUpInfo")
      .pipe(take(1))
      .subscribe((data: any) => {
        this.setValue("BackUpFolderDirectory", data.BackUpFolderDirectory);
        this.setValue("SetTimerBackUp", data.SetTimerBackUp);
        this.model.BackUpFolderDirectory = data.BackUpFolderDirectory;
        this.model.SetTimerBackUp = data.SetTimerBackUp;
      });
  }

  fullBackup() {
    this.httpCommonService
      .get("Home/FullBackup")
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (res)
            this.sts.showToast("success", "", this.translate("ClientApp.Projects.FrameWorkShell.Header.BackUp.SupportVersionCreateSuccessful"));
        },
        (error) => {
          this.sts.showDialog(
            this.translate("ClientApp.Projects.FrameWorkShell.Header.BackUp.SupportSpecifiedSupportVersion"),
            this.translate("ClientApp.Projects.FrameWorkShell.Header.Error")
          );
        }
      );
  }
  async save() {
    this.model.BackUpFolderDirectory = this.formGroup.controls["BackUpFolderDirectory"].value;
    this.model.SetTimerBackUp = this.formGroup.controls["SetTimerBackUp"].value;
    this.httpCommonService
      .create("UserLocalSetting/UpdateBackUpModel", this.model)
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          if (!data) return;
          this.fullBackup();
        },
        (error) => {
          console.log(error);
        }
      );
    this.close();
  }
}
